import React from 'react';
import { getAuthHeaders } from '../supabaseClient';

const API = 'https://tm-audit-platform-production.up.railway.app';

// Copy for the one-active-browser-per-account guard (backend/session-guard.js).
// Deliberately names no place: IP geolocation is approximate and once told the
// owner his account was "active in City A" while he was in City B.
export const SESSION_COPY = {
  conflict: 'Your account is signed in on another device.',
  conflictAction: 'Sign in here instead',
  signedOut: 'You were signed out because your account was used on another device.',
};

// "Sign in here instead" → ends the other device's session. Resolves to
// 'ok' | 'signed_out' | 'error'.
export async function takeOverSession() {
  try {
    const res = await fetch(API + '/api/sessions/take-over', {
      method: 'POST',
      headers: await getAuthHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({}),
    });
    if (res.ok) return 'ok';
    const body = await res.json().catch(() => ({}));
    return body.code === 'session_signed_out' ? 'signed_out' : 'error';
  } catch {
    return 'error';
  }
}

// kind: 'conflict' (offers the take-over button) | 'signed_out' (message only).
function SessionNotice({ kind, onTakeOver, busy, failed }) {
  if (kind === 'signed_out') {
    return <div className="session-notice" role="status">{SESSION_COPY.signedOut}</div>;
  }
  return (
    <div className="session-notice" role="status">
      <span>{SESSION_COPY.conflict}</span>
      <button type="button" className="session-notice-action" onClick={onTakeOver} disabled={busy}>
        {busy ? 'Signing in…' : SESSION_COPY.conflictAction}
      </button>
      {failed && <span className="session-notice-sub">That didn't go through. Please try again.</span>}
    </div>
  );
}

export default SessionNotice;
